<template>
  <div class="star-toggle-buttons">
    <fa
      v-if="value === true"
      :icon="['fas', 'star']"
      class="solid-star-icon cursor-pointer"
      fixed-width
      @click="$emit('click', false)"
    />
    <fa
      v-else
      :icon="['far', 'star']"
      class="regular-star-icon cursor-pointer"
      fixed-width
      @click="$emit('click', true)"
    />
  </div>
</template>

<script>
export default {
  name: 'Star',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.star-toggle-buttons {
    .regular-star-icon {
        font-size: 20px;
        color: #d1d1d1;
        margin-right: 10px;
    }

    .solid-star-icon {
        font-size: 20px;
        color: #e5bf00;
        margin-right: 10px;
    }
}
</style>
